import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Button from 'react-bootstrap/Button';
import Toast from 'react-bootstrap/Toast';
import Form from 'react-bootstrap/Form';


class BasketURLCreator extends Component {
  state = {
    url: "",
    open: false,
    urlCopied: false,
    schoolID: false,
    orgID: ""
  };

  createURL = () => {
    const { basket } = this.props;
    const packages = basket.map(item => item.packageID).toString();
    const packageQuantities = basket
      .map(item => item.packageQuantity)
      .toString();
    const additionalUsers = basket.map(item => item.additionalUsers).toString();
    const organisationParam = this.state.orgID && `&orgID=${this.state.orgID}`;

    const url = `${window.location.origin + window.location.pathname}?brand=${
      this.props.brand
    }&packages=${packages}&packagequantities=${packageQuantities}&additionalusers=${additionalUsers}${organisationParam}`;
    this.setState({ url, open: true });
  };

  copyUrl = () => {
    const copyText = document.getElementById("url-link");

    /* Select the text field */
    copyText.select();

    /* Copy the text inside the text field */
    document.execCommand("copy");

    /* Alert the copied text */
    this.setState({ urlCopied: true });
  };

  handleClose = () => {
    this.setState({ open: false, urlCopied: false });
  };
  handleChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };
  handleTextChange = (event, name) => {
    this.setState({ [name]: event.target.value });
  };

  render() {
    return (
      <div
        style={{
          position: "fixed",
          bottom: "10px",
          right: "1px"
        }}
      >
        <Button
          variant="fab"
          color="secondary"
          onClick={() => this.createURL()}
        >
          <i className="fa fa-link"></i>
        </Button>
        <Toast
          id="url-creator__Toast"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          open={this.state.open}
          autoHideDuration={null}
          onClose={this.handleClose}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          action={[
            <div id="url-creator__Toast__action">
              <Button
                key="copy"
                size="small"
                onClick={this.copyUrl}
              >
                Copy Link
              </Button>
              <Button
                key="copy"
                color="secondary"
                size="small"
                onClick={this.handleClose}
              >
                CLOSE
              </Button>
            </div>
          ]}
          message={
            <div id="url-creator__Toast__message">
              <Form.Text
                id="url-link"
                label="Link"
                value={this.state.url}
                InputProps={{
                  readOnly: true
                }}
                margin="normal"
                onClick={this.copyUrl}
              />
              <br />

                  <Form.Check
                    checked={this.state.schoolID}
                    onChange={this.handleChange("schoolID")}
                    value="schoolID"
                    color="primary"
                    className="form__label--white-text"
                    label="add school"
                  />

              <br />
              {this.state.schoolID && (
                <Form.Text
                  id="school-id"
                  label="School ID"
                  value={this.state.orgID}
                  margin="normal"
                  onChange={event => this.handleTextChange(event, "orgID")}
                  onBlur={this.createURL}
                />
              )}
              {this.state.urlCopied && (
                <span>
                  <i>url has been copied!</i>
                </span>
              )}
            </div>
          }
        />
      </div>
    );
  }
}

BasketURLCreator.propTypes = {
  brand: PropTypes.string,
  basket: PropTypes.array
};

export default BasketURLCreator;
